import { AttentionsListType } from "../../../../../models/list"

export const convertData = (data: AttentionsListType[]): AttentionsListType[] =>
  data.map((item, index) => ({
    ...item,
    id: index,
  }))
